export class YoutubeVideo {
  id: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  videoId: string;
  publishTime: Date;


  constructor(obj?: any) {
    this.id              = obj && obj.id             || null;
    this.title           = obj && obj.title          || null;
    this.description     = obj && obj.description    || null;
    this.thumbnailUrl    = obj && obj.thumbnailUrl   || null;
    this.publishTime    = obj && obj.publishTime   || null;
    this.videoId        = obj && obj.videoId       ||
                         `https://www.youtube.com/watch?v=${this.id}`;
  }
}

export class YoutubeChannel {
  channelId: string;
  channelTitle: string;
  thumbnails: any;

  constructor(obj?: any) {
    this.channelId     = obj && obj.channelId    || null;
    this.channelTitle  = obj && obj.channelTitle || null;
    this.thumbnails    = obj && obj.thumbnails   || null;
  }
}

export class YoutubeVideoDetails {
    id: string;
  viewCount: string;
  likeCount: string;
  dislikeCount: string;
  date: Date;

  constructor(obj?: any) {
    this.id      = obj && obj.id      || null;
    this.viewCount      = obj && obj.viewCount      || null;
    this.likeCount      = obj && obj.likeCount      || null;
    this.dislikeCount  = obj && obj.dislikeCount  || null;
    this.date  = obj && obj.date  || null;

  }
}

export class YouTubeApiSearchResponse{
  etag: string;
  items: YouTubeApiSearchResponseItem[];
  kind: string;
  nextPageToken: string;
  //pageInfo: {totalResults: 1000000, resultsPerPage: 10}
  regionCode: string
  constructor(ApiSearchResponse:any){
    if(ApiSearchResponse.hasOwnProperty('etag')){
      this.etag = ApiSearchResponse['etag'];
    }
    if(ApiSearchResponse.hasOwnProperty('items')){
      this.items = [];
      ApiSearchResponse['items'].map(ele => {
        let newItem = new YouTubeApiSearchResponseItem(ele);
        this.items.push(newItem);
      });
    }
    if(ApiSearchResponse.hasOwnProperty('kind')){
      this.kind = ApiSearchResponse['kind'];
    }
    if(ApiSearchResponse.hasOwnProperty('nextPageToken')){
      this.nextPageToken = ApiSearchResponse['nextPageToken'];
    }
    if(ApiSearchResponse.hasOwnProperty('regionCode')){
      this.regionCode = ApiSearchResponse['regionCode'];
    }
    //todo: page info parsing
  }
}

export class YouTubeApiVideoSearchResponse{
  etag: string;
  items: YouTubeApiVideoSearchResponseItem[];
  kind: string;
  nextPageToken: string;
  //pageInfo: {totalResults: 1000000, resultsPerPage: 10}
  regionCode: string
  constructor(ApiSearchResponse:any){
    if(ApiSearchResponse.hasOwnProperty('etag')){
      this.etag = ApiSearchResponse['etag'];
    }
    if(ApiSearchResponse.hasOwnProperty('items')){
      this.items = [];
      ApiSearchResponse['items'].map(ele => {
        let newItem = new YouTubeApiVideoSearchResponseItem(ele);
        this.items.push(newItem);
      });
    }
    if(ApiSearchResponse.hasOwnProperty('kind')){
      this.kind = ApiSearchResponse['kind'];
    }
    if(ApiSearchResponse.hasOwnProperty('nextPageToken')){
      this.nextPageToken = ApiSearchResponse['nextPageToken'];
    }
    if(ApiSearchResponse.hasOwnProperty('regionCode')){
      this.regionCode = ApiSearchResponse['regionCode'];
    }
    //todo: page info parsing
  }
}

export class YouTubeApiSearchResponseItem{
  etag: string;
  id: YouTubeApiSearchResponseId;
  kind: string;
  snippet: YouTubeApiSearchResponseSnippet;
  constructor(apiResp:any){
    if(apiResp.hasOwnProperty('etag')){
      this.etag = apiResp['etag'];
    }
    if(apiResp.hasOwnProperty('id')){
      this.id = new YouTubeApiSearchResponseId(apiResp['id']);
    }
    if(apiResp.hasOwnProperty('kind')){
      this.kind = apiResp['kind'];
    }
    if(apiResp.hasOwnProperty('snippet')){
      this.snippet = new YouTubeApiSearchResponseSnippet(apiResp['snippet']);
    }


  }
}
export class YouTubeApiVideoSearchResponseItem{
  etag: string;
  id: YouTubeApiVideoSearchResponseId;
  kind: string;
  snippet: YouTubeApiVideoSearchResponseSnippet;
  constructor(apiResp:any){
    if(apiResp.hasOwnProperty('etag')){
      this.etag = apiResp['etag'];
    }
    if(apiResp.hasOwnProperty('id')){
      this.id = new YouTubeApiVideoSearchResponseId(apiResp['id']);
    }
    if(apiResp.hasOwnProperty('kind')){
      this.kind = apiResp['kind'];
    }
    if(apiResp.hasOwnProperty('snippet')){
      this.snippet = new YouTubeApiVideoSearchResponseSnippet(apiResp['snippet']);
    }


  }
}

export class YouTubeApiSearchResponseId{
  kind:string;
  channelId:string;
  constructor(apiResponseId:any){
    if(apiResponseId.hasOwnProperty('kind')){
      this.kind = apiResponseId['kind'];
    }
    if(apiResponseId.hasOwnProperty('channelId')){
      this.channelId = apiResponseId['channelId'];
    }
  }
}
export class YouTubeApiVideoSearchResponseId{
  kind:string;
  videoId:string;
  constructor(apiResponseId:any){
    if(apiResponseId.hasOwnProperty('kind')){
      this.kind = apiResponseId['kind'];
    }
    if(apiResponseId.hasOwnProperty('videoId')){
      this.videoId = apiResponseId['videoId'];
    }
  }
}

export class YouTubeApiSearchResponseSnippet{
  publishedAt: string;
  channelId: string;
  title: string;
  description: string;
  thumbnails: YouTubeApiSearchResponseSnippetThumbnails;
  constructor(apiResponseSnippet:any){
    if(apiResponseSnippet.hasOwnProperty('publishedAt')){
      this.publishedAt = apiResponseSnippet['publishedAt'];
    }
    if(apiResponseSnippet.hasOwnProperty('channelId')){
      this.channelId = apiResponseSnippet['channelId'];
    }
    if(apiResponseSnippet.hasOwnProperty('title')){
      this.title = apiResponseSnippet['title'];
    }
    if(apiResponseSnippet.hasOwnProperty('description')){
      this.description = apiResponseSnippet['description'];
    }
    if(apiResponseSnippet.hasOwnProperty('thumbnails')){
      this.thumbnails = new YouTubeApiSearchResponseSnippetThumbnails(apiResponseSnippet['thumbnails']);
    }

  }
}
export class YouTubeApiVideoSearchResponseSnippet{
  publishedAt: string;
  publishTime: string;
  channelId: string;
  channelTitle: string;
  title: string;
  description: string;
  thumbnails: YouTubeApiSearchResponseSnippetThumbnails;
  constructor(apiResponseSnippet:any){
    if(apiResponseSnippet.hasOwnProperty('publishedAt')){
      this.publishedAt = apiResponseSnippet['publishedAt'];
    }
    if(apiResponseSnippet.hasOwnProperty('channelId')){
      this.channelId = apiResponseSnippet['channelId'];
    }
    if(apiResponseSnippet.hasOwnProperty('title')){
      this.title = apiResponseSnippet['title'];
    }
    if(apiResponseSnippet.hasOwnProperty('description')){
      this.description = apiResponseSnippet['description'];
    }
    if(apiResponseSnippet.hasOwnProperty('publishTime')){
      this.publishTime = apiResponseSnippet['publishTime'];
    }
    if(apiResponseSnippet.hasOwnProperty('channelTitle')){
      this.channelTitle = apiResponseSnippet['channelTitle'];
    }
    if(apiResponseSnippet.hasOwnProperty('thumbnails')){
      this.thumbnails = new YouTubeApiSearchResponseSnippetThumbnails(apiResponseSnippet['thumbnails']);
    }

  }
}

export class YouTubeApiSearchResponseSnippetThumbnails{
  default: YouTubeApiSearchResponseSnippetThumbnail;
  high: YouTubeApiSearchResponseSnippetThumbnail;
  medium: YouTubeApiSearchResponseSnippetThumbnail;
  constructor(apiResponseSnippetThubnails:any){
    if(apiResponseSnippetThubnails.hasOwnProperty('default')){
      this.default = new YouTubeApiSearchResponseSnippetThumbnail(apiResponseSnippetThubnails['default']);
    }
    if(apiResponseSnippetThubnails.hasOwnProperty('high')){
      this.high = new YouTubeApiSearchResponseSnippetThumbnail(apiResponseSnippetThubnails['high']);
    }
    if(apiResponseSnippetThubnails.hasOwnProperty('medium')) {
      this.medium = new YouTubeApiSearchResponseSnippetThumbnail(apiResponseSnippetThubnails['medium']);
    }
  }
}

export class YouTubeApiSearchResponseSnippetThumbnail{
  url: string;
  width: number;
  height: number;
  constructor(apiResponseSnippetThumbnail:any){
    if(apiResponseSnippetThumbnail.hasOwnProperty('url')){
      this.url = apiResponseSnippetThumbnail['url'];
    }
    if(apiResponseSnippetThumbnail.hasOwnProperty('width')){
      this.width = apiResponseSnippetThumbnail['width'];
    }
    if(apiResponseSnippetThumbnail.hasOwnProperty('height')){
      this.height = apiResponseSnippetThumbnail['height'];
    }
  }
}